import Compressor from "compressorjs";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import React from "react";
import { Alert, Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { Photo } from "../assets/svgs/Icons";
import { storage } from "../firebase";

export default function UploadImages({
  loading,
  setLoading,
  urls,
  setUrls,
  uid,
}) {
  const types = ["image/png", "image/jpeg"];

  const showToast = (message, type, toastId) => {
    const options = { type: type, toastId: toastId };
    toast(message, options);
  };

  function selectImages(e) {
    setLoading(true);

    let selected = e.target.files;

    if (selected && selected.length > 0) {
      var errorUpload = false;

      if (selected.length + urls.length <= 5) {
        for (var i = 0; i < selected.length; ++i) {
          if (!types.includes(selected[i].type)) {
            showToast(
              "Bitte eine Bilddatei hochladen! (png oder jpg/jpeg)",
              toast.TYPE.ERROR
            );
            errorUpload = true;
            break;
          }
        }
      } else {
        showToast("Maximal 5 Bilder pro Anzeige!", toast.TYPE.WARNING);
        errorUpload = true;
      }

      if (!errorUpload) {
        for (var j = 0; j < selected.length; ++j) {
          new Compressor(selected[j], {
            quality: 0.8,
            convertTypes: ["image/png"],
            convertSize: 0.1,
            width: 1024, //640,
            height: 576, //480,
            resize: "cover",

            // The compression process is asynchronous,
            // which means you have to access the `result` in the `success` hook function.
            success(result) {
              const storageRef = ref(storage, "/" + uid + "/" + result.name);
              uploadBytesResumable(storageRef, result).on(
                "state-changed",
                (snapshot) => {
                  //
                },
                (err) => {
                  console.error(err);
                },
                () => {
                  getDownloadURL(storageRef).then((downloadURL) => {
                    setUrls((urls) => [...urls, downloadURL]);
                  });
                }
              );

              showToast(
                "Bild(er) erfolgreich hochgeladen.",
                toast.TYPE.SUCCESS,
                "success" + urls.length
              );
            },
            error(e) {
              console.log(e.message);
            },
          });
        }
      }
    } else {
      showToast("Bitte eine Bilddatei auswählen! (png oder jpg/jpeg)");
    }

    setLoading(false);
  }

  return (
    <>
      <Row>
        <Col>
          <div className="">
            hochgeladene Bilder:
            <br />
            {urls.length} / 5
          </div>
        </Col>
        <Col>
          <Alert
            variant="info"
            className="align-items-center"
            style={{ padding: "2%", marginLeft: "0%", marginRight: "0%" }}
          >
            <p
              style={{ margin: "0px", textAlign: "center", fontSize: "0.8em" }}
            >
              Bitte achte darauf Fotos im Querformat aufzunehmen!
            </p>
          </Alert>
        </Col>
      </Row>
      <form className="d-flex justify-content-center align-items-center">
        <label
          className="d-flex justify-content-center align-items-center"
          style={{
            width: "70%",
            cursor: "pointer",
            borderStyle: "solid",
            borderWidth: "1px",
            maxHeight: "60px",
            borderRadius: "5px",
          }}
        >
          <Photo />
          <h1
            style={{
              fontSize: "2.4vh",
              margin: "0%",
              padding: "7% 7% 7% 3px",
              whiteSpace: "nowrap",
            }}
          >
            Foto(s) hochladen
          </h1>
          <input
            multiple
            disabled={loading}
            type="file"
            accept="image/*"
            onChange={selectImages}
            style={{ display: "none" }}
          />
        </label>
      </form>
    </>
  );
}
